import { useLayoutEffect, useRef, useState } from "react";

// 把子内容按可用高度等比缩小，使其始终完整落在容器内、不产生滚动条——
// 复刻登录页「1920×1080 画布缩放适配视口、永不出现滚动条」的思路，
// 用于注册 / 找回密码 / 重置密码等旧版流式表单页：
//   · 内容比可用高度高时按比例缩小（最大 1:1，绝不放大）；
//   · 内容放得下时 scale=1，布局与原来完全一致。
// 仅在父容器高度被锁定（如 ≥lg 的 h-svh）时才会触发缩放；父容器可自由增高（移动端 min-h）时
// 可用高度 = 内容高度 → scale 恒为 1，页面照常流式滚动，移动端行为不变。
export default function FitScale({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const outer = useRef<HTMLDivElement>(null);
  const inner = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);

  // offsetHeight / ResizeObserver 报告的都是「未经 transform 的布局高度」，
  // 因此即便已应用 scale，need 仍是内容的自然高度，可安全反复计算。
  useLayoutEffect(() => {
    const o = outer.current;
    const i = inner.current;
    if (!o || !i) return;
    const update = () => {
      const avail = o.clientHeight;
      const need = i.offsetHeight;
      setScale(need > avail && avail > 0 ? avail / need : 1);
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(o);
    ro.observe(i);
    return () => ro.disconnect();
  }, []);

  return (
    <div
      ref={outer}
      className={className}
      style={{ display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}
    >
      <div ref={inner} style={{ width: "100%", transform: `scale(${scale})`, transformOrigin: "center" }}>
        {children}
      </div>
    </div>
  );
}
